import React from "react";
import TrackSearchResult from "../components/TrackSearchResult";

const Home = ({ recentTracks, chooseTrack, playingTrack }) => {
    return (
        <div class="block-wrapper">
            <h2 class="block-heading">Recent Listened
            </h2>
            <div className="track-layout recent-tracks">
                {recentTracks.map((track) => (
                    <TrackSearchResult
                        track={track}
                        key={track.uri}
                        chooseTrack={chooseTrack}
                        playingTrack={playingTrack}
                    />
                ))}
            </div>
        </div>
    );
};

export default Home;